export const actions = {
    GET_HELPDESK_LIST: 'GET_HELPDESK_LIST',
    SET_HELPDESK_LIST: 'SET_HELPDESK_LIST',

    GET_HELPDESK_MESSAGE: 'GET_HELPDESK_MESSAGE',
    SET_HELPDESK_MESSAGE: 'SET_HELPDESK_MESSAGE',

    GET_HELPDESK_ASSIGNEDUSER: 'GET_HELPDESK_ASSIGNEDUSER',
    SET_HELPDESK_ASSIGNEDUSER: 'SET_HELPDESK_ASSIGNEDUSER',
    
    POST_HELPDESK_CREATE: 'POST_HELPDESK_CREATE',
    SET_HELPDESK_CREATE: 'SET_HELPDESK_CREATE',
};